import styled from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  padding: ${spacing[2]};
  box-sizing: border-box;
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.xl};
  background: ${rawColors.structural.white};
  box-shadow: 0 ${spacing[2.5]} ${spacing[2]} rgb(0 0 0 / 4%), 0 ${spacing[1]} ${spacing[0.5]} rgb(0 0 0 / 10%);
`;

export const Search = styled.label`
  display: flex;
  align-items: center;
  gap: ${spacing[2.5]};
  height: ${spacing[8]};
  padding: ${spacing[2]} ${spacing[3]};
  box-sizing: border-box;
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.lg};
  color: ${rawColors.text.lowEmphasis};
`;

export const SearchInput = styled.input`
  min-width: 0;
  padding: ${spacing[0]};
  border: 0;
  outline: 0;
  color: ${rawColors.text.highEmphasis};
  background: transparent;
  ${typographyMixin("caption", 4)}
`;

/** Caps the option list so a long field list scrolls inside the menu, never the panel. */
export const List = styled.div.attrs({ "data-testid": "chart-studio-select-menu-list" })`
  display: flex;
  flex-direction: column;
  min-width: 0;
  max-height: ${spacing[56]};
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
`;

export const Item = styled.button`
  display: flex;
  align-items: center;
  gap: ${spacing[2.5]};
  width: 100%;
  min-height: ${spacing[10]};
  padding: ${spacing[2]} ${spacing[3]};
  border: 0;
  border-radius: ${borderRadius.lg};
  color: ${rawColors.text.highEmphasis};
  background: transparent;
  cursor: pointer;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${typographyMixin("body", 3)}

  &:hover { background: ${rawColors.structural.themeLight}; }
`;

export const ItemIcon = styled.span`
  display: inline-flex;
  flex: 0 0 auto;
  width: ${spacing[4]};
  height: ${spacing[4]};
  align-items: center;
  justify-content: center;
`;
